import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import ReactTable from 'react-table';

import { PropertyManagerViewModel } from '@models/PropertyManager';
import { ContractSimpleViewModel } from '@models/Contract';
// import { CustomerViewModel } from '@services/CustomerService';
import { Link } from 'react-router-dom';
// import { Column } from 'react-table';
import { AddressViewModel } from '@models/common.models';
import * as classes from './property-manager-details.scss';
import { dateParser } from '@common/dateParser';
import { RouteDefinitions, getRoute } from '@common/route-definitions';
import { Breadcrumbs, SpinnerPage } from '@common/components';
import { Role, Roles } from '@models/Roles';

// All properties should be readonly
export interface PropertyManagerDetailsComponentProperties extends RouteComponentProps<{ id?: number }> {
  readonly propertyManagerVM: PropertyManagerViewModel | null;
  readonly contracts: Array<ContractSimpleViewModel>;
  // readonly officeLookup: (query: string, id: number) => Promise<PageViewModel<OfficeSearchViewModel>>;
  readonly errorMessage?: string;
  readonly statusMessage?: string;
  readonly getPropertyManagerDetail: (id: number) => void;
  readonly getContractsForManager: (id?: number) => void;
}

// Component definition
export class PropertyManagerDetailComponent extends React.Component<PropertyManagerDetailsComponentProperties> {
  constructor(props: PropertyManagerDetailsComponentProperties) {
    super(props);
  }

  componentDidMount() {
    if (this.props.match && this.props.match.params.id) {
      this.props.getPropertyManagerDetail(this.props.match.params.id);
      this.props.getContractsForManager(this.props.match.params.id);
    }
  }

  renderContactBy() {
    let contactBy = [];
    if (this.props.propertyManagerVM!.email) {
      contactBy.push('Email');
    }

    if (this.props.propertyManagerVM!.fax) {
      contactBy.push('Fax');
    }

    if (this.props.propertyManagerVM!.usps) {
      contactBy.push('USPS');
    }

    if (this.props.propertyManagerVM!.onlineOrders) {
      contactBy.push('Online Orders');
    }

    return contactBy.join(', ');
  }

  render() {
    if (!this.props.propertyManagerVM) {
      return <SpinnerPage />;
    }
    return (
      <div className={classes.propertyManagerDetail}>
        <Breadcrumbs />
        <div className="row">
          <h2>Property Manager: {this.props.propertyManagerVM!.name}</h2>
          {Role.CheckRoles([Roles.Admin, ...Role.GetAllIBS()]) && (
            <h5 className="ml-10 pl-10">
              <Link
                to={getRoute(RouteDefinitions.propertymanager.Edit, {
                  id: this.props.propertyManagerVM.id
                })}
              >
                Edit
              </Link>
            </h5>
          )}
        </div>
        <div className={classes.container}>
          <div className="row">
            <div className="form-control col-md-3">
              <label>Type</label>
              <h5>
                {this.props.propertyManagerVM!.propMgrType ? this.props.propertyManagerVM!.propMgrType.value : '--'}
              </h5>
            </div>
            <div className="form-control col-md-3">
              <label>Status</label>
              <h5>
                {this.props.propertyManagerVM!.propMgrStatus ? this.props.propertyManagerVM!.propMgrStatus.value : '--'}
              </h5>
            </div>
            <div className="form-control col-md-3">
              <label>Office</label>
              <h5>
                {this.props.propertyManagerVM!.propMgmtOffice
                  ? this.props.propertyManagerVM!.propMgmtOffice!.value
                  : '--'}
              </h5>
            </div>
            <div className="form-control col-md-3">
              <label>Contact By</label>
              <h5>{this.renderContactBy()}</h5>
            </div>
          </div>
          <div className="row">
            {this.props.propertyManagerVM.address ? (
              <>
                <div className="form-control col-md-6">
                  <label>Address 1</label>
                  <h5>{this.props.propertyManagerVM!.address.line1 || '--'}</h5>
                </div>
                <div className="form-control col-md-6">
                  <label>Address 2</label>
                  <h5>{this.props.propertyManagerVM!.address.line2 || '--'}</h5>
                </div>
                <div className="form-control col-md-3">
                  <label>City</label>
                  <h5>{this.props.propertyManagerVM!.address.city || '--'}</h5>
                </div>
                <div className="form-control col-md-3">
                  <label>State</label>
                  <h5>{this.props.propertyManagerVM!.address.state.name || '--'}</h5>
                </div>
                <div className="form-control col-md-3">
                  <label>Zip</label>
                  <h5>{this.props.propertyManagerVM!.address.zip || '--'}</h5>
                </div>
              </>
            ) : (
              ''
            )}
            <div className="form-control col-md-6">
              <label>Email</label>
              <h5>{this.props.propertyManagerVM!.emailAddress || '--'}</h5>
            </div>
            <div className="form-control col-md-3">
              <label>Phone</label>
              <h5>{this.props.propertyManagerVM!.directPhone || '--'}</h5>
            </div>
            <div className="form-control col-md-3">
              <label>Fax</label>
              <h5>{this.props.propertyManagerVM!.directFax || '--'}</h5>
            </div>
          </div>
          {this.props.contracts ? (
            <>
              <div className="row mt-10 pt-10">
                <h5>Contracts</h5>
                <div className="col-xs-12">
                  <ReactTable
                    onPageChange={() => {
                      Array.from(document.getElementsByClassName('rt-tbody')).forEach(element => {
                        element.scrollTop = 0;
                      });
                    }}
                    className="-striped -highlight"
                    columns={
                      [
                        {
                          accessor: (contract: ContractSimpleViewModel) =>
                            contract && (
                              <Link
                                to={{
                                  pathname: getRoute(RouteDefinitions.contract.Details, {
                                    id: contract.id
                                  }),
                                  state: { viewOnly: true }
                                }}
                              >
                                {contract.number}
                              </Link>
                            ),
                          id: 'ContractNumber',
                          Header: 'Contract Number',
                          sortable: false
                        },
                        { accessor: 'contractStatus.value', Header: 'Status', maxWidth: 100, sortable: true },
                        {
                          accessor: 'expirationDate',
                          maxWidth: 100,
                          Cell: (row: { value: string }) => (
                            <span>{dateParser.parse(row.value).format('MM/DD/YYYY')}</span>
                          ),
                          Header: 'Exp. Date',
                          sortable: false
                        },
                        {
                          accessor: 'propertyAddress',
                          Header: 'Address',
                          Cell: (row: { value: AddressViewModel }) => (
                            <span>
                              {row.value
                                ? `${row.value.line1} ${row.value.line2} ${row.value.city} ${
                                    row.value.state.abbreviation
                                  } ${row.value.zip}`
                                : ''}
                            </span>
                          ),
                          sortable: false
                        }
                      ]
                      // {
                      //     accessor: 'agentType',
                      //     Cell: (props: { value: { id: number, value: string } }) => <span>{props.value.value || '--'}</span>,
                      //     Header: 'Type',
                      //     sortable: true,
                      // }
                    }
                    data={this.props.contracts}
                    defaultPageSize={10}
                    loading={!this.props.contracts}
                  />
                </div>
              </div>
            </>
          ) : (
            ''
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/property-manager/_components/property-manager-details/property-manager-details.component.tsx